import React from 'react'
import SupplyBillAgreeCount from './SupplyBillAgreeCount'
import Person4Icon from '@mui/icons-material/Person4';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import VisibilityIcon from '@mui/icons-material/Visibility';

const SupplyBillAgreesCount = ({ supplyBill }) => {

  return (
    <div className='supplyAgrees__column'>
        {
            supplyBill && supplyBill.items ?
                <SupplyBillAgreeCount 
                    items={supplyBill.items}
                    type={'isAgreeSupplyLeader'}
                    title='Погодження начальником постачання'
                    ico={<Person4Icon />}
                />
            : ''
        }
        {
            supplyBill && supplyBill.items ?
                <SupplyBillAgreeCount 
                    items={supplyBill.items}
                    type={'isAgreeEconomist'}
                    title='Погодження економістом'
                    ico={<MonetizationOnIcon />}
                />
            : ''
        }
        {
            supplyBill && supplyBill.items ?
                <SupplyBillAgreeCount 
                    items={supplyBill.items}
                    type={'isAgreeDeputyDirectorSupply'}
                    title='Погодження зам директора постачання'
                    ico={<Diversity2Icon />}
                />
            : ''
        }
        {
            supplyBill && supplyBill.items ?
                <SupplyBillAgreeCount 
                    items={supplyBill.items}
                    type={'isAgreeLeadership'}
                    title='Погодження керівником'
                    ico={<VisibilityIcon />}
                />
            : ''
        }
    </div>
  )
}

export default SupplyBillAgreesCount